export enum StripeProductsIdProdEnum {
	TARIF_UNIQUE_SELOGER = "prod_Rn5jjvNOo6vnny",
	TARIF_UNIQUE = "prod_Rxy9BEvXc1kyCD",
	PACK_5_ESTIMATIONS = "prod_TA7zD3pHFQid9R",
	ABONNEMENT_MENSUEL_ILLIMITE_AGENCE = "prod_TA7qvtqrYviy3R",
	ABONNEMENT_MENSUEL_ILLIMITE_PARTICULIER = "prod_TA7tusKpdPi1XM",
	ABONNEMENT_ANNUEL_ILLIMITE_AGENCE = "prod_TFerRXGXaSj3FK",
	ABONNEMENT_ANNUEL_ILLIMITE_PARTICULIER = "prod_TFetIOXgPpeSCJ"
}

export enum StripeProductsIdPreprodEnum {
	TARIF_UNIQUE_SELOGER = "prod_RLgTLP1ZSr7fu9",
	TARIF_UNIQUE = "prod_RtqISJkBe9sMR4",
	PACK_5_ESTIMATIONS = "prod_TARWTLPCxrGMwH",
	ABONNEMENT_MENSUEL_ILLIMITE_AGENCE = "prod_TARY7cfA1y4SL0",
	ABONNEMENT_MENSUEL_ILLIMITE_PARTICULIER = "prod_TARXN8czpecngO",
	ABONNEMENT_ANNUEL_ILLIMITE_AGENCE = "prod_TFeueUcN6eyY4E",
	ABONNEMENT_ANNUEL_ILLIMITE_PARTICULIER = "prod_TFevqiadKGn1Ed"
}
